import ComponentName from '@Constant/componentName'
import { CREATIVE_MARK } from '@Constant/behaviorTrack'

const creative = [
  {
    component: () => import('../../views/layout/Index.vue'),
    path: '/creative',
    auth: '*',
    name: ComponentName.creative.home,
    redirect: {
      name: ComponentName.creative.index
    },
    children: [
      {
        component: () => import('../../views/creative/new-creative/CreativeList.vue'),
        path: 'next',
        auth: '*',
        name: ComponentName.newCreative.index,
        meta: {
          title: '邀约列表',
          logAuto: {
            pv: true,
            duration: true,
            source: CREATIVE_MARK.PV
          }
        }
      },
      {
        component: () => import('../../views/creative/Index.vue'),
        path: 'index',
        name: ComponentName.creative.index,
        auth: '*',
        meta: {
          title: '邀约列表',
          logAuto: {
            pv: true,
            duration: true,
            source: CREATIVE_MARK.PV
          }
        },
        children: [
          {
            component: () => import('../../views/creative/Detail.vue'),
            path: 'detail/:id',
            name: ComponentName.creative.detail,
            props: true,
            auth: '*',
            meta: {
              title: '邀约详情'
            }
          }
        ]
      },
      {
        component: () => import('../../views/creative/Create.vue'),
        path: 'create',
        name: ComponentName.creative.create,
        auth: '*',
        meta: {
          title: '新建邀约'
        }
      },
      {
        component: () => import('../../views/creative/Copy.vue'),
        path: 'copy/:id',
        name: ComponentName.creative.copy,
        auth: '*',
        props: true,
        meta: {
          title: '邀约复制'
        }
      }
    ]
  }
]

export default creative
